var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.btnBack,on:{"click":_vm.handleBack}},[_c('icon-arrow-left'),_vm._v(_vm._s(_vm._f("uppercase")(_vm.$t("Back")))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }